import { InsertWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Insert')
export class InsertConnectorProvider extends ConnectorProvider<InsertWorkflowNode> {}
